<template>
    <scroll-content
        :distance="300"
        :isArticle="article"
        :afterScroll="afterScroll"
        @over-scroll="overScrollHandler"
        @before-destroyed="fixedScrollHandler"
    >
        <list-items :loading="loading" :isLast="isLast" :isArticle="article">
            <list-item
                v-for="(item, index) in todos"
                :key="item.articleIdx"
                :id="item.articleIdx"
                :schoolId="item.schoolId"
                :boardIdx="item.boardIdx"
                :title="item.schoolName"
                :file="item.file"
                :image="item.image"
                :received_at="item.posted_at"
                :isSchool="school"
                :isArticle="article"
            >
                <template v-slot:notice-type>
                    <notice-type
                        :color="item.boardColor"
                        :isSchool="school"
                        :isArticle="article"
                        @click="goBoard(item.schoolId, item.boardIdx)"
                    >
                        <icon :size="1.8" :marginRight="0.8" :name="item.type" />
                        <div>
                            {{ item.boardName }}
                        </div>
                    </notice-type>
                </template>

                <template v-slot:title-icon>
                    <school-icon :size="4.8" :marginRight="0.4" :path="item.schoolProfUrl" />
                </template>

                <template v-slot:content>
                    <notice-title @click="goView(item.articleIdx)">
                        <div class="notice-title">{{ item.title }}</div>
                        <div v-html="item.content" />
                    </notice-title>
                </template>

                <template v-slot:footer>
                    <notice-footer>
                        <div class="footer-button" @click="newsFollowHandler(item, index)">
                            <heart-icon :active="item.isKeeped === 1 ? true : false" />
                            담아두기
                        </div>
                        <div class="footer-button" @click="shareModalHandler(item)">
                            <icon name="share" :size="2.1" :marginRight="0.8" />
                            공유하기
                        </div>
                    </notice-footer>
                </template>
            </list-item>
        </list-items>
    </scroll-content>
</template>
<script>
import { dataEncoded } from "../../../utils/lib";

import ListItems from "../../../components/ListItems";
import ListItem from "../../../components/ListItem";
import ScrollContent from "../../../components/ScrollContent";

import SchoolIcon from "../../../components/SchoolIcon";
import Icon from "../../../components/Icon";
import HeartIcon from "../../../components/HeartIcon.vue";

import { NoticeType, NoticeTitle, NoticeFooter } from "../../../components/palette";

export default {
    name: "CommonListTemplate",
    props: {
        todos: Array,
        loading: Boolean,
        isLast: Boolean,
        school: Boolean, // school 에서 렌더링 할때
        article: Boolean, // article 에서 렌더링 할때
        afterScroll: Number,
        isSchoolPage: {
            type: Boolean,
            default: () => false
        },
        onFixedScroll: Function
    },

    methods: {
        overScrollHandler() {
            if (!this.loading && !this.isLast) {
                this.$emit("get-more");
            }
        },

        fixedScrollHandler(scroll) {
            this.onFixedScroll && this.onFixedScroll(scroll);
            this.$emit("fixed-scroll", scroll);
        },

        async newsFollowHandler({ articleIdx, isKeeped }, index) {
            const keepType = isKeeped === 0 ? 1 : 2;
            const _alret = keepType === 1 ? "게시물을 담아 두었습니다." : "담아둔 게시물을 <b>제거</b>하였습니다.";

            try {
                const data = dataEncoded({
                    token: this.$store.state.user.token,
                    articleIdx,
                    keepType
                });

                this.$emit("keeping", { articleIdx, next: isKeeped === 0 ? 1 : 0 });
                await this.$api.notice.doKeeping(data);

                this.$alert("success", _alret);
            } catch (e) {
                this.$emit("keeping", { articleIdx, next: isKeeped === 0 ? 1 : 0 });
                this.$alert("error", "담아두기를 실패하셨습니다.");
            }
        },

        shareModalHandler({ shareUrl }) {
            this.$store.commit("notice/SET_SHARE_URL", shareUrl);
        },

        goBoard(schoolId, boardIdx) {
            if (!boardIdx || this.$route.name.toLowerCase() === "school") return;
            this.$router.push(`/school/${schoolId}/${boardIdx}`);
        },

        goView(articleIdx) {
            // article 이면 이동 안되게 하자.
            if (this.article) return;
            this.$router.push(`/article/${articleIdx}`);
        }
    },
    components: {
        ListItems,
        ListItem,
        ScrollContent,
        SchoolIcon,
        Icon,
        NoticeType,
        NoticeTitle,
        NoticeFooter,
        HeartIcon
    }
};
</script>
